var _toConsumableArray = require("/Users/lukechilds/dev/oss/ledger-kmd-rewards/node_modules/@babel/runtime/helpers/toConsumableArray");

var bs58check = require('bs58check');

var _require = require('varuint-bitcoin'),
    numberToCompactSizeUInt = _require.encode;

var _require2 = require('bitcoin-ops'),
    OP_DUP = _require2.OP_DUP,
    OP_HASH160 = _require2.OP_HASH160,
    OP_EQUALVERIFY = _require2.OP_EQUALVERIFY,
    OP_CHECKSIG = _require2.OP_CHECKSIG;

var addressDecode = function addressDecode(address) {
  return bs58check.decode(address).slice(1);
};

var checkUInt53 = function checkUInt53(number) {
  if (number < 0 || !Number.isSafeInteger(number)) {
    throw new RangeError('value out of range');
  }
};

var numberToUInt64 = function numberToUInt64(number) {
  checkUInt53(number);
  var buffer = Buffer.alloc(8);
  buffer.writeUInt32LE(number >>> 0);
  buffer.writeUInt32LE(number / 0x100000000 | 0, 4);
  return buffer;
};

var buildOutputScript = function buildOutputScript(outputs) {
  if (!Array.isArray(outputs)) {
    throw new TypeError("Expected 'outputs' to be of type 'array', got: '".concat(outputs, "'."));
  }

  if (outputs.length === 0) {
    throw new TypeError('\'outputs\' cannot be an empty array.');
  }

  var outputScript = _toConsumableArray(numberToCompactSizeUInt(outputs.length));

  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = outputs[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var _step$value = _step.value,
          address = _step$value.address,
          value = _step$value.value;
      var pubKeyHash = addressDecode(address);
      var scriptPubKey = [OP_DUP, OP_HASH160, pubKeyHash.length].concat(_toConsumableArray(pubKeyHash), [OP_EQUALVERIFY, OP_CHECKSIG]);
      outputScript = _toConsumableArray(outputScript).concat(_toConsumableArray(numberToUInt64(value)), _toConsumableArray(numberToCompactSizeUInt(scriptPubKey.length)), _toConsumableArray(scriptPubKey));
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return != null) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return Buffer.from(outputScript).toString('hex');
};

module.exports = buildOutputScript;